import React, { useEffect, useState } from 'react';
import WithMainContainer from '@/components/layout';
import { Button, Layout, Tabs } from 'antd';
import pp from './ProductPage.module.scss';
import { Carousel, Typography } from 'antd';
import { useRouter } from 'next/router';
import Link from 'next/link';

const DrawerProductSellers = dynamic(
    () => import('@/components/ProductPage/DrawerProductSellers'),
    {},
);
const DrawerProductDescription = dynamic(
    () => import('@/components/ProductPage/DrawerProductDescription'),
    {},
);

const ModalProductView3DModel = dynamic(
    // @ts-ignore
    () => import('@/components/ProductPage/ModalProductView3DModel'),
    {},
);

import { EPopupNotificationType, EProfileType } from 'tkmp-lib/src/enums';
import { getCookie } from 'cookies-next';
import { IBreadcrumb } from 'tkmp-lib/src/interfaces';
import Head from 'next/head';
import ProductDistributorItem from '@/components/ProductPage/ProductDistributorItem/ProductDistributorItem';
import { useStores } from '@/utils/hooks/useStores';
import { AuthService } from 'tkmp-lib/src/services/AuthService';
import { QueryService } from 'tkmp-lib/src/services/QueryService';
import { usePopup } from 'tkmp-lib/src/hooks/usePopup';
import { CompareButton, FavouriteButton, ModelButton } from '@/widgets/ItemButtons/ItemButtons';
import dynamic from 'next/dynamic';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';

export async function getServerSideProps(context: any) {
    // На случай если AuthService.validateAuthSSR(cookies) не будет работать
    const isAuth = await AuthService.checkRefreshSSR(context);
    const { product_query } = context.params;
    const cookies = context?.req?.cookies;

    const locale = QueryService.getLocale(context);

    const product = await QueryService.request(
        `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${locale}/product/${product_query}`,
    );

    if (product) {
        // Поменять на AuthService.validateAuthSSR(cookies)
        if (isAuth) {
            const token = context?.req?.cookies?.accessToken;

            const comparedList = await QueryService.request(
                `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${locale}/profile/compare/item`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            );
            const isCompare =
                comparedList?.filter((f: any) => f.productSlug === product?.info?.slug).length > 0;

            const basketList = await QueryService.request(
                `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${locale}/profile/basket`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            );
            const isBasket = basketList?.items?.some((f: any) =>
                f.items?.some((item: any) => item.tool?.slug === product?.info?.slug),
            );

            const favouriteList = await QueryService.request(
                `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${locale}/profile/favourite`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            );
            const isFavourite =
                favouriteList?.items?.filter((f: any) => f.slug === product?.info?.slug).length > 0;

            return {
                props: {
                    product,
                    isFavourite,
                    isCompare,
                    isBasket,
                    comparedList,
                    favouriteList,
                    basketList,
                    userIsViewer: false,
                },
            };
        } else {
            context.req.cookies = {};
        }
    }

    return {
        props: {
            product,
            isFavourite: false,
            isCompare: false,
            isBasket: false,
            comparedList: [],
            favouriteList: [],
            basketList: [],
            userIsViewer: true,
        },
    };
}

const ProductPage = WithMainContainer(
    ({
        product,
        isFavourite,
        isCompare,
        isBasket,
        comparedList,
        favouriteList,
        basketList,
        userIsViewer,
    }: any) => {
        const router = useRouter();
        const LOCALIZATION = useLocalization();
        const [openModalProductView3DModel, setOpenModalProductView3DModel] = useState(false);
        // console.log('product', product);
        // console.log('favouriteList', favouriteList);
        // console.log('basketList', basketList);
        // console.log('isBasket', isBasket);
        const handleCloseModalProductView3DModel = () => {
            setOpenModalProductView3DModel(false);
        };

        const [drawerProductDescription, setDrawerProductDescription] = useState(false);
        const handleCloseDrawerProductDescriptionClose = () => {
            setDrawerProductDescription(false);
        };

        const [drawerProductSellers, setDrawerProductSellers] = useState(false);
        const handleCloseDrawerProductSellersClose = () => {
            setDrawerProductSellers(false);
        };

        const [isViewer, setIsViewer] = useState<boolean>(userIsViewer);
        const [userComparedList, setUserComparedList] = useState<any>(comparedList);
        const [userFavouriteList, setUserFavouriteList] = useState<any>(favouriteList);
        const [userBasketList, setUserBasketList] = useState<any>(basketList.items);
        const [isSelectedToCompare, setIsSelectedToCompare] = useState<boolean>(isCompare);
        const [isSelectedToFavourite, setIsSelectedToFavourite] = useState<boolean>(isFavourite);
        const [isSelectedToBasket, setIsSelectedToBasket] = useState<boolean>(isBasket);

        const { notification } = usePopup();

        const {
            userStore: { USERROLE, clearUser },
            systemStore: { BREADCRUMBS, setBreadcrumbs },
            modalsStore: { openLoginForm },
        } = useStores();

        useEffect(() => {
            setIsViewer((USERROLE as EProfileType) !== EProfileType.Buyer);
        }, [USERROLE]);

        useEffect(() => {
            // if (!product || (product.error && product.status && product.timestamp)) {
            //     router.push({
            //         pathname: '/error',
            //     });
            // } else {
            //     setBreadcrumbs(BREADCRUMBS.filter((f: any) => !/product/gm.test(f)));
            // }
        }, []);

        // для обновления списка товаров в корзине при удалении или добавлении
        useEffect(() => {
            QueryService.request(
                `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${LOCALIZATION.locale}/profile/basket`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${getCookie('accessToken')}`,
                    },
                },
            ).then((response: any) => {
                setUserBasketList(response?.items);
            });
        }, [isSelectedToBasket]);

        // для обновления списка сравнения
        useEffect(() => {
            QueryService.request(
                `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${LOCALIZATION.locale}/profile/compare/item`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${getCookie('accessToken')}`,
                    },
                },
            ).then((response: any) => {
                setUserComparedList(response);
                console.log('response', response);
            });
        }, [isSelectedToCompare]);

        // для обновления списка избранных
        useEffect(() => {
            QueryService.request(
                `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${LOCALIZATION.locale}/profile/favourite`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${getCookie('accessToken')}`,
                    },
                },
            ).then((response: any) => {
                setUserFavouriteList(response);
                console.log('response', response);
            });
        }, [isSelectedToFavourite]);

        useEffect(() => {
            if (process.env.NEXT_PUBLIC_DEBUG === 'true') console.log('PRODUCT => ', product);
            if (product?.info?.name) {
                let resultBreadcrumbs: IBreadcrumb[] = [
                    {
                        key: '/',
                        title: LOCALIZATION.routes.home,
                    },
                    {
                        key: '/catalog',
                        title: LOCALIZATION.routes.catalog,
                    },
                ];

                resultBreadcrumbs = [
                    ...resultBreadcrumbs,
                    ...product?.category?.name_path
                        .slice(1)
                        .reduce((acc: any, current: any, index: any) => {
                            const path =
                                acc.length > 0
                                    ? `${acc[acc.length - 1].key}/${current}`
                                    : `${resultBreadcrumbs?.at(-1)?.key}/${current}`;
                            return [
                                ...acc,
                                { key: path, title: product?.category?.alias_path[index + 1] },
                            ];
                        }, []),
                    { key: `/product/${product?.info?.name}`, title: product?.info?.alias },
                ];
                console.log(resultBreadcrumbs);
                setBreadcrumbs(resultBreadcrumbs);
            }
        }, [product, LOCALIZATION.locale]);
        const changeCompareProduct = () => {
            AuthService.validateAuth().then((answer) => {
                if (answer) {
                    const isExist = !!userComparedList?.find(
                        (f: any) => f.prodSlug === product?.info?.slug,
                    );

                    QueryService.request(
                        `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${LOCALIZATION.locale}/profile/compare/item`,
                        {
                            method: isExist ? 'DELETE' : 'PUT',
                            headers: {
                                Authorization: `Bearer ${getCookie('accessToken')}`,
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                distributorSlug: product?.manufacture?.slug,
                                productSlug: product?.info?.slug,
                            }),
                        },
                    ).then((_) => {
                        if (typeof window !== 'undefined')
                            notification.success({
                                message:
                                    LOCALIZATION.pages.product.notification.changeCompareProduct
                                        .message,
                                description: !isSelectedToCompare
                                    ? LOCALIZATION.pages.product.notification.changeCompareProduct
                                          .notSelected
                                    : LOCALIZATION.pages.product.notification.changeCompareProduct
                                          .selected,
                            });
                        setIsSelectedToCompare((prevState) => !prevState);
                    });
                } else {
                    AuthService.logout().then((_) => clearUser());
                }
            });
        };

        const changeFavouriteProduct = () => {
            AuthService.validateAuth().then((answer) => {
                if (answer) {
                    const isExist = !!userFavouriteList?.items?.find(
                        (f: any) => f.slug === product?.info?.slug,
                    );
                    console.log();
                    QueryService.request(
                        `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${LOCALIZATION.locale}/profile/favourite/item`,
                        {
                            method: isExist ? 'DELETE' : 'PUT',
                            headers: {
                                Authorization: `Bearer ${getCookie('accessToken')}`,
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                slug: product?.info?.slug,
                                name: product?.info?.name,
                                article: product?.info?.article,
                                description: product?.info?.description,
                                logo: product?.info?.icon,
                            }),
                        },
                    ).then((_) => {
                        if (typeof window !== 'undefined')
                            notification.success({
                                message:
                                    LOCALIZATION.pages.product.notification.changeFavouriteProduct
                                        .message,
                                description: !isSelectedToFavourite
                                    ? LOCALIZATION.pages.product.notification.changeFavouriteProduct
                                          .notSelected
                                    : LOCALIZATION.pages.product.notification.changeFavouriteProduct
                                          .selected,
                            });
                        setIsSelectedToFavourite((prevState) => !prevState);
                    });
                } else {
                    AuthService.logout().then((_) => clearUser());
                }
            });
        };
        const changeBasketProduct = (orgSlug: any, prodSlug: any) => {
            AuthService.validateAuth().then((answer) => {
                if (answer) {
                    const isExist = !!userBasketList?.some((f: any) =>
                        f.items?.some((item: any) => item.tool.slug === prodSlug),
                    );
                    console.log('isExist', isExist);
                    console.log('prodSlug', prodSlug);
                    QueryService.request(
                        `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${LOCALIZATION.locale}/profile/basket/item`,
                        {
                            method: 'PUT',
                            headers: {
                                Authorization: `Bearer ${getCookie('accessToken')}`,
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                orgSlug: orgSlug,
                                prodSlug: prodSlug,
                                count: isExist ? 0 : 1,
                            }),
                        },
                    ).then((_) => {
                        setIsSelectedToBasket(!isExist);
                        if (typeof window !== 'undefined')
                            notification.success({
                                message:
                                    LOCALIZATION.pages.product.notification.changeBasketProduct
                                        .message,
                                description: !isExist
                                    ? LOCALIZATION.pages.product.notification.changeBasketProduct
                                          .notSelected
                                    : LOCALIZATION.pages.product.notification.changeBasketProduct
                                          .selected,
                            });
                    });
                } else {
                    AuthService.logout().then((_) => clearUser());
                }
            });
        };

        return (
            <>
                {process.env.NEXT_PUBLIC_INCLUDE_SEO_TAGS === 'true' && (
                    <Head>
                        <title>{`${product?.info?.name} - TKMP.Istok`}</title>
                        <meta
                            name="description"
                            content={`Купить ${product?.info?.name} на TKMP.Istok. ${product?.info?.description}`}
                        />
                        <meta
                            name="keywords"
                            content={`товары, ${product?.category?.alias_path?.join(', ')}, ${product?.category?.fpathSlug?.join(', ')}, B2B, маркетплейс, закупки, ${product?.info?.name}`}
                        />
                        <meta
                            name="author"
                            content="Команда TKMP.Istok"
                        />

                        <meta
                            property="og:title"
                            content={`${product?.info?.name} - TKMP.Istok`}
                        />
                        <meta
                            property="og:description"
                            content={product?.info?.description}
                        />
                        <meta
                            property="og:url"
                            content={`${process.env.NEXT_PUBLIC_DOMAIN}/product/${product?.info?.tid}`}
                        />
                        <meta
                            property="og:image"
                            content={`${process.env.NEXT_PUBLIC_DOMAIN_CDN}${product?.info?.icon}`}
                        />
                        <meta
                            property="og:type"
                            content="product"
                        />
                        <meta
                            property="og:site_name"
                            content="TKMP.Istok"
                        />

                        <meta
                            name="twitter:card"
                            content="summary_large_image"
                        />
                        <meta
                            name="twitter:title"
                            content={`${product?.info?.name} - TKMP.Istok`}
                        />
                        <meta
                            name="twitter:description"
                            content={product?.info?.description}
                        />
                        <meta
                            name="twitter:image"
                            content={`${process.env.NEXT_PUBLIC_DOMAIN_CDN}${product?.info?.icon}`}
                        />
                    </Head>
                )}
                <Layout className={pp.container}>
                    <Layout className={pp.itemHead}>
                        <span className={pp.itemName}>{product?.info?.name}</span>
                        <Layout className={pp.itemOtherInfo}>
                            <span className={pp.itemOtherInfoArticule}>
                                {LOCALIZATION.pages.product.leftCard.article}{' '}
                                {product?.info?.article}
                            </span>
                            <Layout className={pp.itemOtherInfoRating}>
                                <Layout className={pp.itemOtherInfoStars}>
                                    {/*<div className={cicss.rating} style={{'--rate': '4.7'}}>*/}
                                    {/*    <div className={cicss.star}></div>*/}
                                    {/*    <div className={cicss.star}></div>*/}
                                    {/*    <div className={cicss.star}></div>*/}
                                    {/*    <div className={cicss.star}></div>*/}
                                    {/*    <div className={cicss.star}></div>*/}
                                    {/*</div>*/}
                                </Layout>
                                <span className={pp.itemOtherInfoRatingCount}>
                                    {product?.reviews ? product?.reviews : ''}
                                </span>
                            </Layout>
                        </Layout>
                    </Layout>
                    <Layout className={pp.itemBlock}>
                        <Layout className={pp.itemLeftSide}>
                            <Layout className={pp.itemLeftSideBody}>
                                <Layout
                                    className={pp.itemPictures}
                                    style={{ maxWidth: '536px' }}
                                >
                                    <Carousel
                                        arrows
                                        infinite={true}
                                        autoplay
                                        className={pp.itemPictureCarousel}
                                    >
                                        {product?.media?.image.map(
                                            (image: { miid: any; url: any }, i: any) => {
                                                return (
                                                    <div key={image.miid ?? i}>
                                                        <div
                                                            style={{
                                                                backgroundImage: `url("${process.env.NEXT_PUBLIC_DOMAIN_CDN}${image.url}")`,
                                                                backgroundSize: 'contain',
                                                                backgroundRepeat: 'no-repeat',
                                                                backgroundPosition: 'center',
                                                                width: '536px',
                                                                height: '529px',
                                                            }}
                                                        ></div>
                                                    </div>
                                                );
                                            },
                                        )}
                                    </Carousel>
                                    <Layout className={pp.itemPictures_controls}></Layout>
                                </Layout>
                                <Layout className={pp.itemLeftSideBodyDescription}>
                                    <Layout className={pp.itemShortDescriptionBlock}>
                                        <table className={pp.itemDescriptionShort}>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        {
                                                            LOCALIZATION.pages.product.leftCard
                                                                .manufacturer
                                                        }
                                                    </td>
                                                    <td>{product?.manufacture?.name}</td>
                                                </tr>
                                                {product?.parameter?.map((el: any, i: any) => {
                                                    if (i > 2) return;
                                                    return (
                                                        <tr key={i}>
                                                            <td>{el.description}</td>
                                                            <td>{el.value}</td>
                                                        </tr>
                                                    );
                                                })}
                                                {product?.parameter?.length > 4 ? (
                                                    <tr>
                                                        <td
                                                            colSpan={2}
                                                            style={{ padding: 0 }}
                                                        >
                                                            <Button
                                                                type={'link'}
                                                                className={pp.linkFullDescription}
                                                                onClick={() => {
                                                                    setDrawerProductDescription(
                                                                        true,
                                                                    );
                                                                }}
                                                            >
                                                                {
                                                                    LOCALIZATION.pages.product
                                                                        .leftCard.allCar
                                                                }
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    ''
                                                )}
                                            </tbody>
                                        </table>
                                    </Layout>
                                    {/*<Layout className={pp.itemParameters}>*/}
                                    {/*    <span style={{fontWeight: 500}}>Параметры</span>*/}
                                    {/*    <Select className={pp.itemParametersSelect}/>*/}
                                    {/*</Layout>*/}
                                    {/*<Layout className={pp.itemVarietyFieldsBlock}>*/}
                                    {/*    <span style={{fontWeight: 500}}>Области применения</span>*/}
                                    {/*    <Layout className={pp.itemVarietyFields}>*/}
                                    {/*        <Link className={pp.itemVarietyField} href={''}>Сталь</Link>*/}
                                    {/*        <Link className={pp.itemVarietyField} href={''}>Нержавеющая сталь</Link>*/}
                                    {/*        <Link className={pp.itemVarietyField} href={''}>Цветные металлы</Link>*/}
                                    {/*        <Link className={pp.itemVarietyField} href={''}>Чугун</Link>*/}
                                    {/*    </Layout>*/}
                                    {/*</Layout>*/}
                                    <Layout className={pp.itemBottomLinks}>
                                        {/*<Link href={''} className={pp.itemDescriptionBottomLink}>Задать вопрос о товаре*/}
                                        {/*    производителю</Link> TODO: FIX GKINSTURMENT ISSUE*/}
                                        <Link
                                            href={`/catalog/${product?.category?.fpathSlug?.slice(1)[0]}/brand/${product?.manufacture?.short_name ?? 'GKInstrument'}`}
                                            className={pp.itemDescriptionBottomLink}
                                        >
                                            {LOCALIZATION.pages.product.leftCard.allManItems}
                                        </Link>
                                        <Link
                                            href={`/catalog/${product?.category?.fpathSlug?.slice(1).join('/')}`}
                                            className={pp.itemDescriptionBottomLink}
                                        >
                                            {LOCALIZATION.pages.product.leftCard.allClassItems}
                                        </Link>
                                    </Layout>
                                </Layout>
                            </Layout>
                            <Tabs className={pp.itemFullDescriptionTabs} />
                        </Layout>
                        <Layout className={pp.itemRightSide}>
                            <Layout className={pp.itemRightSide__controls}>
                                {product?.media?.model?.length > 0 && (
                                    <ModelButton
                                        width={24}
                                        height={24}
                                        onClick={() => {
                                            setOpenModalProductView3DModel(true);
                                        }}
                                        text={LOCALIZATION.pages.product.rightCard.open3D}
                                    />
                                )}
                                {!isViewer && (
                                    <>
                                        <FavouriteButton
                                            width={24}
                                            height={24}
                                            onClick={() => changeFavouriteProduct()}
                                            active={isSelectedToFavourite}
                                            text={
                                                isSelectedToFavourite
                                                    ? LOCALIZATION.pages.product.rightCard
                                                          .isSelectedToFavourite.true
                                                    : LOCALIZATION.pages.product.rightCard
                                                          .isSelectedToFavourite.false
                                            }
                                        />
                                        <CompareButton
                                            width={24}
                                            height={24}
                                            onClick={() => changeCompareProduct()}
                                            active={isSelectedToCompare}
                                            text={
                                                isSelectedToCompare
                                                    ? LOCALIZATION.pages.product.rightCard
                                                          .isSelectedToCompare.true
                                                    : LOCALIZATION.pages.product.rightCard
                                                          .isSelectedToCompare.false
                                            }
                                        />
                                    </>
                                )}
                            </Layout>
                            <Layout className={pp.itemBracketBlock}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>{LOCALIZATION.pages.product.rightCard.time}</td>
                                            <td>
                                                {LOCALIZATION.pages.product.rightCard.timeStatus}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{LOCALIZATION.pages.product.rightCard.cost}</td>
                                            <td>
                                                {LOCALIZATION.pages.product.rightCard.costStatus}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <Button
                                    type={isSelectedToBasket ? 'primary' : 'default'}
                                    className={pp.itemButton}
                                    onClick={() => {
                                        if (isViewer) openLoginForm();
                                        else
                                            changeBasketProduct(
                                                product?.manufacture?.mid,
                                                product?.info?.tid,
                                            );
                                    }}
                                >
                                    {isSelectedToBasket
                                        ? LOCALIZATION.pages.product.rightCard.isSelectedToCompare
                                              .true
                                        : LOCALIZATION.pages.product.rightCard.isSelectedToCompare
                                              .false}
                                </Button>
                            </Layout>
                            <Layout className={pp.itemBracketRecommendations}>
                                {product?.commodity?.count === 0 ? (
                                    <Typography.Text className={`text-16-400`}>
                                        {
                                            LOCALIZATION.pages.product.rightCard
                                                .bracketRecommendations.commodityCount
                                        }
                                    </Typography.Text>
                                ) : (
                                    product?.commodity?.list?.map((item: any, i: any) => (
                                        <ProductDistributorItem
                                            key={i}
                                            item={item}
                                            changeBasketProduct={changeBasketProduct}
                                            isViewer={isViewer}
                                            openLoginForm={openLoginForm}
                                        />
                                    ))
                                )}
                            </Layout>
                        </Layout>
                    </Layout>
                    <Layout className={pp.itemPlaylists}>{/*этот товар из подборок*/}</Layout>
                    <Layout className={pp.itemRecomendations}>{/*еще могут подойти*/}</Layout>
                    <Layout className={pp.itemsHistory}>{/*ранее просмотренные*/}</Layout>

                    <DrawerProductDescription
                        data={product}
                        callback_close={handleCloseDrawerProductDescriptionClose}
                        callback_open={drawerProductDescription}
                    />
                    <DrawerProductSellers
                        callback_close={handleCloseDrawerProductSellersClose}
                        callback_open={drawerProductSellers}
                        tempPrice={product?.price?.value}
                    />
                    {product?.media?.model.length > 0 && (
                        <ModalProductView3DModel
                            callback_open={openModalProductView3DModel}
                            callback_close={handleCloseModalProductView3DModel}
                            // url={`${process.env.REACT_APP_DOMAIN_CDN}/content/model/e6dac82b-ed67-420f-bd10-b75913ea7834`}
                            url={`${process.env.NEXT_PUBLIC_DOMAIN_CDN}${product?.media?.model[0].url}`}
                        />
                    )}
                </Layout>
            </>
        );
    },
);

export default ProductPage;
